import { isBoolean } from 'lodash';
import { useOnboarding } from '../../../../redux/reducer/content';
import { useUser } from '../../../../redux/reducer/user';
import { useService } from '../../../../redux/reducer/service';
import { ONBOARDING_STEPS_TYPES } from '../../constants';

export const useOnboardingConditions = () => {
  const { isOnboardingStarted, completedSteps } = useOnboarding();
  const { isFirstEntry, profile } = useUser();
  const { serviceData } = useService();

  const isOnboardingAvailable = isBoolean(isFirstEntry) && !!serviceData;

  const shouldShowOnboardingStep = (step) => {
    return isOnboardingStarted && !completedSteps.includes(step);
  };

  const isLoginOlderThanTwoMonths = (previousLoginAt) => {
    if (typeof previousLoginAt !== 'number' || previousLoginAt <= 0) return false;

    const now = Math.floor(Date.now() / 1000); // в секундах
    return previousLoginAt < now - 60 * 60 * 24 * 60; // 60 дней (2 месяца) в секундах
  };

  return {
    isOnboardingAvailable,
    shouldShowOnboardingStep,
    isNewUser: isFirstEntry || isLoginOlderThanTwoMonths(profile?.previous_login_at),
    canStartOnboarding: !completedSteps.includes(ONBOARDING_STEPS_TYPES.START),
  };
};
